angular.module('gym.waivers').controller('WaiverRetractConsentRequestModalCtrl', ["$scope", "$modalInstance", function($scope, $modalInstance) {
  $scope.params = {
    message: ''
  };
  $scope.submit = function() {
    return $modalInstance.close($scope.params.message);
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
